// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"25":"StartLesson","94":"Login","309":"homeView","639":"SetTraining"}[chunkId] + "." + {"25":"748032c8","94":"97bf298e","309":"f1f4e348","639":"4f5cc790"}[chunkId] + ".js";
};